import { JxtBookingParticipationStatusIconEnum } from '@jooxter/utils';

export const JxtBookingParticipationStatusIconInfo = {
  [JxtBookingParticipationStatusIconEnum.Accepted]: {
    iconName: 'fa-check',
    iconColor: 'text-green-150',
    iconBackgroundColor: 'bg-green-20',
  },
  [JxtBookingParticipationStatusIconEnum.Declined]: {
    iconName: 'fa-times',
    iconColor: 'text-red-150',
    iconBackgroundColor: 'bg-red-20',
  },
  [JxtBookingParticipationStatusIconEnum.Unknown]: {
    iconName: 'fa-question',
    iconColor: 'text-neutral-140',
    iconBackgroundColor: 'bg-neutral-10',
  },
  [JxtBookingParticipationStatusIconEnum.Left]: {
    iconName: 'fa-arrow-right-from-bracket',
    iconColor: 'text-neutral-140',
    iconBackgroundColor: 'bg-neutral-10',
  },
  [JxtBookingParticipationStatusIconEnum.AcceptedRemotely]: {
    iconName: 'fa-check',
    iconColor: 'text-green-150',
    iconBackgroundColor: 'bg-green-20',
  },
};
